import React, { useEffect, useState } from 'react';
import { WifiOff, RefreshCw, Loader2 } from 'lucide-react';
import { api } from '../services/api';

// Full-screen fallback when the backend is unreachable; auto-retries and hides itself once the API answers
const ServerErrorScreen = () => {
  const [down, setDown] = useState(false);
  const [checking, setChecking] = useState(false);

  useEffect(() => {
    const h = (e) => setDown(!!e.detail?.down);
    window.addEventListener('api-status', h);
    return () => window.removeEventListener('api-status', h);
  }, []);

  useEffect(() => {
    if (!down) return undefined;
    const t = setInterval(() => api.get('/').catch(() => {}), 10000);
    return () => clearInterval(t);
  }, [down]);

  const retry = async () => {
    setChecking(true);
    try { await api.get('/'); window.location.reload(); } catch { /* still down */ } finally { setChecking(false); }
  };

  if (!down) return null;
  return (
    <div className="fixed inset-0 z-[100] bg-[#0e0e10] text-white flex items-center justify-center p-6" data-testid="server-error-screen">
      <div className="absolute inset-0 opacity-[0.07] bg-[radial-gradient(circle_at_1px_1px,#fff_1px,transparent_0)] [background-size:22px_22px]" />
      <div className="relative max-w-md text-center animate-[fadeUp_.6s_ease-out_both]">
        <div className="w-20 h-20 mx-auto rounded-full bg-orange-500/15 border border-orange-500/40 flex items-center justify-center mb-6"><WifiOff size={36} className="text-orange-400" /></div>
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-orange-400 mb-3">Maintenance</p>
        <h1 className="text-3xl sm:text-4xl font-black leading-tight">Nous revenons dans un instant</h1>
        <p className="text-gray-400 mt-3 text-sm sm:text-base">Nos serveurs ne répondent pas pour le moment. Votre panier et vos données sont conservés — réessayez dans quelques secondes.</p>
        <button type="button" onClick={retry} disabled={checking} data-testid="server-error-retry" className="mt-8 inline-flex items-center gap-2 bg-orange-500 hover:bg-orange-600 disabled:opacity-60 text-white font-semibold px-6 py-3 rounded-full transition-colors">
          {checking ? <Loader2 size={18} className="animate-spin" /> : <RefreshCw size={18} />} Réessayer
        </button>
        <p className="text-xs text-gray-500 mt-4">Vérification automatique toutes les 10 secondes.</p>
      </div>
    </div>
  );
};

export default ServerErrorScreen;
